export default "__VITE_ASSET__BkUUNu6u__"